import { render, staticRenderFns } from "./ManejoTelefonos.vue?vue&type=template&id=4ba7f556"
import script from "./ManejoTelefonos.vue?vue&type=script&lang=js"
export * from "./ManejoTelefonos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports